import api from '../api';
import axios from 'axios';
import { ENDPOINTS } from '../../constants/apiEndpoints';

export const fetchMembers = () => {
  return api.get(ENDPOINTS.member_master.url);
};

export const saveMemberDetails = (memberData) => {
  console.log('MEMBER DATA', JSON.stringify(memberData));
  const requestDTO = {
    data: JSON.stringify(memberData),
    target: 'society.models.master.member.Member',
    compressed: false
  };
  return api.post(ENDPOINTS.member_master.url, requestDTO);
};

export const fetchMemberById = (id) => {
  return api.get(`${ENDPOINTS.member_master.url}/${id}`);
};

// member init
export const fetchMemberMasterData = () => {
  return api.get(ENDPOINTS.member_master.url);
};

// option values with method fallback
export const fetchOptionValues = async (groups = []) => {
  // API expects a raw JSON array body like ["MEMBER_MASTER"]
  // Use configured api client so auth/interceptors are applied
  return api.post(ENDPOINTS.option_values.url, groups);
};

export const fetchPincodeDetails = async (pincode) => {
  // GET request to fetch pincode details
  return api.get(`${process.env.REACT_APP_API_URL}/lgd/${pincode}`);
};

// fetch member by member number
export const fetchMemberByMemberNumber = (memberNumber) => {
  const encodedMemberNumber = btoa(memberNumber.toString());
  return api.get(`${process.env.REACT_APP_API_URL}/master/member-master/member-no/${encodedMemberNumber}`);
};

// fetch introducer by introducer number
export const fetchIntroducerByNumber = (introducerNumber) => {
  const encodedIntroducerNumber = btoa(introducerNumber.toString());
  return api.get(`${process.env.REACT_APP_API_URL}/master/member-master/member-no/${encodedIntroducerNumber}`);
};

// file upload
export const uploadMemberFiles = (transactionId, memberId, documentType, formData) => {
  // Create a new FormData object to include memberId and documentType
  const uploadFormData = new FormData();
  
  // Add the file from the original formData
  if (formData.has('file')) {
    uploadFormData.append('file', formData.get('file'));
  }
  
  // Add memberId (base64 encoded)
  uploadFormData.append('memberId', memberId);
  
  // Add documentType
  uploadFormData.append('documentType', documentType);
  
  // Use axios directly to avoid baseURL conflicts
  return axios.post(`${process.env.REACT_APP_API_URL}/file/upload/${transactionId}`, uploadFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': sessionStorage.getItem('token') || '',
    },
    withCredentials: true,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    timeout: 60000, // 60 seconds timeout for large files
  });
};

// file download
export const downloadMemberFile = async (filename) => {
  const encodedFilename = btoa(filename);
  
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/file/download?file=${encodedFilename}`, {
      headers: {
        'Authorization': sessionStorage.getItem('token') || '',
      },
      withCredentials: true,
      responseType: 'blob', // Important for file downloads
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// add introducer
export const addIntroducer = (introducerData) => {
  const requestDTO = {
    data: JSON.stringify(introducerData),
    target: 'society.models.master.member.MemberIntroducer',
    compressed: false
  };
  return api.post(`${process.env.REACT_APP_API_URL}/master/member-master/introducer`, requestDTO);
};

// remove/update introducer
export const removeIntroducer = (introducerData) => {
  const requestDTO = {
    data: JSON.stringify(introducerData),
    target: 'society.models.master.member.MemberIntroducer',
    compressed: false
  };
  return api.post(`${process.env.REACT_APP_API_URL}/master/member-master/introducer`, requestDTO);
};

// delete address
export const deleteAddress = (addressData) => {
  const requestDTO = {
    data: JSON.stringify(addressData),
    target: 'society.models.master.member.MemberAddress',
    compressed: false
  };
  return api.post(`${process.env.REACT_APP_API_URL}/master/member-master/address`, requestDTO);
};
